export default "__VITE_ASSET__CiPvSbOd__"